import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Nav, NavDropdown, MenuItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { componentSets } from '../util/util';

import './ReportSelector.css';

class ReportSelector extends Component {
  isCurrentPath(report) {
    return `${this.props.basePath}/${report.key}` === this.props.currentPath;
  }

  render() {
    const currentReport = componentSets.find(report => this.isCurrentPath(report));
    const amount = typeof this.props.amount === 'number' ? `?amount=${this.props.amount}` : '';

    return (
      <Nav className="ReportSelector" >
        <b>select component set to display</b>
        <NavDropdown title={(currentReport && currentReport.title) || ''} id="ReportSelector" >
          {componentSets.map(report => (
            <LinkContainer to={`${this.props.basePath}/${report.key}${amount}`} key={report.key} >
              <MenuItem>{report.title}</MenuItem>
            </LinkContainer>
          ))}
        </NavDropdown>
      </Nav>
    );
  }
}

ReportSelector.propTypes = {
  basePath: PropTypes.string,
  currentPath: PropTypes.string,
  amount: PropTypes.number,
};

export default ReportSelector;



// WEBPACK FOOTER //
// ./src/components/foodDetail/ReportSelector.js